module.exports = __webpack_public_path__ + "img/life_quote.15ef2f84.png";